import { Colors } from '@oy/uicore';
import React from 'react';
import { IconName } from './IconName';
import {
  IconAccountIdentity,
  IconAccounts,
  IconAdd,
  IconAnalytic,
  IconApiBiller,
  IconApiDisbursement,
  IconApiEwallet,
  IconApiHitReport,
  IconApiInquiry,
  IconApiOfflineCashIn,
  IconApiOfflineCashOut,
  IconApiTransactionsData,
  IconArrowDown,
  IconArrowLeft,
  IconArrowLeftOutline,
  IconArrowRight,
  IconArrowRightOutline,
  IconArrowUp,
  IconBack,
  IconBahasa,
  IconBank,
  IconBell,
  IconBook,
  IconBulkDisbursement,
  IconBurger,
  IconCalendar,
  IconCamera,
  IconCash,
  IconChain,
  IconChat,
  IconCheckmarkBoxSelected,
  IconCheckmarkBoxUnselected,
  IconCheckmarkBoxUnselectedDisabled,
  IconCheckmarkSelected,
  IconCheckmarkSelectedDisabled,
  IconCheckmarkUnselected,
  IconCheckmarkUnselectedDisabled,
  IconChevronRight,
  IconClaimFund,
  IconClock,
  IconClose,
  IconClose2,
  IconCloseFilled,
  IconCollapse,
  IconColumn,
  IconConfigs,
  IconCopy,
  IconCreditCard,
  IconCreditDebitCard,
  IconDelete,
  IconDelete2,
  IconDesktop,
  IconDocument,
  IconDone,
  IconDotDrag,
  IconDotMenu,
  IconDotMenuVertical,
  IconDoubleArrowLeft,
  IconDoubleArrowRight,
  IconDownload,
  IconEarningTransaction,
  IconEdit,
  IconEditBorder,
  IconEmail,
  IconEnglish,
  IconEquals,
  IconEwallet,
  IconExclamation,
  IconExclamationOutlined,
  IconExperiment,
  IconExternalLink,
  IconEye,
  IconEyeSlash,
  IconFilter,
  IconForm,
  IconForward,
  IconGallery,
  IconGlobal,
  IconGuidelines,
  IconHeadphone,
  IconHelp,
  IconHome,
  IconIdentity,
  IconInformation,
  IconInformationFilled,
  IconIntegration,
  IconInvoice,
  IconJpgThumbnail,
  IconKebabMenu,
  IconKey,
  IconKeyboard,
  IconLaptop,
  IconLoading,
  IconMapMarker,
  IconMaximizeArrow,
  IconMegaphone,
  IconMinimizeArrow,
  IconMinus,
  IconMoney,
  IconMultiAccountManagement,
  IconOffice,
  IconOverdraft,
  IconPastDueDate,
  IconPaymentCheckout,
  IconPaymentRouting,
  IconPdfThumbnail,
  IconPen,
  IconPendingIncome,
  IconPhone,
  IconPlan,
  IconPromo,
  IconQris,
  IconReceipt,
  IconRefresh,
  IconReply,
  IconRequestMoney,
  IconRetail,
  IconRupiah,
  IconRupiahFilled,
  IconSafeBox,
  IconSave,
  IconScheduledDisbursement,
  IconSearch,
  IconSecurity,
  IconSendMoney,
  IconSettings,
  IconShare,
  IconShield,
  IconSort,
  IconSpending,
  IconSpendingTransaction,
  IconSquareCheckmark,
  IconSquareUncheck,
  IconSquareWarning,
  IconStar,
  IconStarAngled,
  IconStarAngledBorder,
  IconStarBorder,
  IconTimeFilled,
  IconTopUp,
  IconTransactionList,
  IconTransactionReport,
  IconUpload,
  IconUploadFile,
  IconVendor,
  IconVirtualAccount,
  IconVirtualCreditCard,
  IconVmark,
  IconWarning,
  IconWhatsApp,
  IconWithdrawal,
  IconXlsxThumbnail,
} from './Icons';
import IconArrowLeftFilled from './Icons/IconArrowLeftFilled';
import IconArrowRightFilled from './Icons/IconArrowRightFilled';
import IconDocxThumbnail from './Icons/IconDocxThumbnail';
import IconDocxThumbnailText from './Icons/IconDocxThumbnailText';
import IconFAQ from './Icons/IconFAQ';
import IconForwardAlt from './Icons/IconForwardAlt';
import IconSquareCheck from './Icons/IconSquareCheck';
import IconTimeOutline from './Icons/IconTimeOutline';
import IconXlsxThumbnailText from './Icons/IconXlsxThumbnailText';

// TODO remove unused icon and its reference
/// IMPORTANT!! If you want tou add an/some icon/s you should insert it alphabetically either in import or in code bellow
const RenderIcons = (name: IconName | null, fill: string, size?: number) => {
  switch (name) {
    case 'accounts':
      return <IconAccounts fill={fill} />;
    case 'account-identity':
      return <IconAccountIdentity fill={fill} />;
    case 'account-receivable/invoice':
      return <IconWithdrawal fill={fill} />;
    case 'account-receivable/customer-management':
      return <IconMultiAccountManagement fill={fill} />;
    case 'add':
      return <IconAdd fill={fill} />;
    case 'analytic':
      return <IconAnalytic fill={fill} />;
    case 'api-hit-report':
      return <IconApiHitReport fill={fill} />;
    case 'api-hit-report/api-transactions-data':
      return <IconApiTransactionsData fill={fill} />;
    case 'api-inquiry':
      return <IconApiInquiry fill={fill} />;
    case 'arrow-down':
      return <IconArrowDown fill={fill} />;
    case 'arrow-left':
      return <IconArrowLeft fill={fill} />;
    case 'arrow-right':
      return <IconArrowRight fill={fill} />;
    case 'arrow-left-filled':
      return <IconArrowLeftFilled fill={fill} />;
    case 'arrow-right-filled':
      return <IconArrowRightFilled fill={fill} />;
    case 'arrow-left-outline':
      return <IconArrowLeftOutline fill={fill} />;
    case 'arrow-right-outline':
      return <IconArrowRightOutline fill={fill} />;
    case 'arrow-up':
      return <IconArrowUp fill={fill} />;
    case 'back':
      return <IconBack fill={fill} />;
    case 'bell':
      return <IconBell fill={fill} />;
    case 'book':
      return <IconBook fill={fill} />;
    case 'burger':
      return <IconBurger fill={fill} />;
    case 'business-banking':
      return <IconWithdrawal fill={fill} />;
    case 'calendar':
      return <IconCalendar fill={fill} />;
    case 'camera':
      return <IconCamera fill={fill} />;
    case 'chain':
      return <IconChain fill={fill} />;
    case 'chat':
      return <IconChat fill={fill} />;
    case 'checkmark-box-unselected':
      return <IconCheckmarkBoxUnselected fill={fill} />;
    case 'checkmark-box-selected':
      return <IconCheckmarkBoxSelected fill={fill} />;
    case 'checkmark-box-selected-disabled':
      return <IconCheckmarkBoxSelected fill={Colors.BLACK40} />;
    case 'checkmark-box-unselected-disabled':
      return <IconCheckmarkBoxUnselectedDisabled />;
    case 'checkmark-selected-disabled':
      return <IconCheckmarkSelectedDisabled fill={fill} />;
    case 'checkmark-selected':
      return <IconCheckmarkSelected fill={fill} />;
    case 'checkmark-unselected':
      return <IconCheckmarkUnselected fill={Colors.BLACK100} />;
    case 'checkmark-unselected-disabled':
      return <IconCheckmarkUnselectedDisabled />;
    case 'chevron-right':
      return <IconChevronRight fill={fill} />;
    case 'clock':
      return <IconClock fill={fill} />;
    case 'close':
      return <IconClose fill={fill} />;
    case 'close2':
      return <IconClose2 fill={fill} />;
    case 'close-filled':
      return <IconCloseFilled fill={fill} />;
    case 'collapse':
      return <IconCollapse fill={fill} />;
    case 'column':
      return <IconColumn fill={fill} />;
    case 'configs':
      return <IconConfigs fill={fill} />;
    case 'copy':
      return <IconCopy fill={fill} />;
    case 'delete':
      return <IconDelete fill={fill} />;
    case 'delete-line':
      return <IconDelete2 fill={fill} />;
    case 'desktop':
      return <IconDesktop fill={fill} />;
    case 'disbursement/api-disburse':
      return <IconApiDisbursement fill={fill} />;
    case 'disbursement/api-biller':
      return <IconApiBiller fill={fill} />;
    case 'disbursement/api-offline/cash-out':
      return <IconApiOfflineCashOut fill={fill} />;
    case 'disbursement/bulk':
      return <IconBulkDisbursement fill={fill} />;
    case 'disbursement/claim-fund':
      return <IconClaimFund fill={fill} />;
    case 'disbursement/scheduled':
      return <IconScheduledDisbursement fill={fill} />;
    case 'disbursement/offline-cash-withdrawal':
      return <IconWithdrawal fill={fill} />;
    case 'disbursement/virtual-card':
      return <IconVirtualCreditCard fill={fill} />;
    case 'document':
      return <IconDocument fill={fill} />;
    case 'docx-thumbnail':
      return <IconDocxThumbnail fill={fill} />;
    case 'docx-thumbnail-text':
      return <IconDocxThumbnailText fill={fill} />;
    case 'dot-drag':
      return <IconDotDrag fill={fill} />;
    case 'dot-menu':
      return <IconDotMenu fill={fill} />;
    case 'dot-menu-vertical':
      return <IconDotMenuVertical fill={fill} />;
    case 'double-arrow-left':
      return <IconDoubleArrowLeft fill={fill} />;
    case 'double-arrow-right':
      return <IconDoubleArrowRight fill={fill} />;
    case 'download':
      return <IconDownload fill={fill} />;
    case 'earning-transaction':
      return <IconEarningTransaction />;
    case 'edit':
      return <IconEdit fill={fill} />;
    case 'email':
      return <IconEmail fill={fill} />;
    case 'equals':
      return <IconEquals fill={fill} />;
    case 'exclamation':
      return <IconExclamation fill={fill} />;
    case 'exclamation-outlined':
      return <IconExclamationOutlined fill={fill} />;
    case 'eye':
      return <IconEye fill={fill} />;
    case 'eye-slash':
      return <IconEyeSlash fill={fill} />;
    case 'external-link':
      return <IconExternalLink fill={fill} size={size} />;
    case 'experiment':
      return <IconExperiment fill={fill} />;
    case 'faq':
      return <IconFAQ fill={fill} />;
    case 'filter':
      return <IconFilter fill={fill} />;
    case 'form':
      return <IconForm fill={fill} />;
    case 'forward':
      return <IconForward fill={fill} />;
    case 'forward-alt':
      return <IconForwardAlt fill={fill} />;
    case 'gallery':
      return <IconGallery fill={fill} />;
    case 'global':
      return <IconGlobal fill={fill} />;
    case 'guidelines':
      return <IconGuidelines fill={fill} />;
    case 'headphone':
      return <IconHeadphone fill={fill} />;
    case 'help':
      return <IconHelp fill={fill} />;
    case 'home':
      return <IconHome fill={fill} />;
    case 'information':
      return <IconInformation fill={fill} />;
    case 'information-filled':
      return <IconInformationFilled fill={fill} />;
    case 'integration':
      return <IconIntegration fill={fill} />;
    case 'identity':
      return <IconIdentity fill={fill} />;
    case 'jpg-thumbnail':
      return <IconJpgThumbnail fill={fill} />;
    case 'kebab-menu':
      return <IconKebabMenu fill={fill} />;
    case 'key':
      return <IconKey fill={fill} />;
    case 'laptop':
      return <IconLaptop fill={fill} />;
    case 'map-marker':
      return <IconMapMarker fill={fill} />;
    case 'maximize-arrow':
      return <IconMaximizeArrow fill={fill} />;
    case 'megaphone':
      return <IconMegaphone fill={fill} />;
    case 'minimize-arrow':
      return <IconMinimizeArrow fill={fill} />;
    case 'minus':
      return <IconMinus fill={fill} />;
    case 'money':
      return <IconMoney fill={fill} />;
    case 'multi-account-management':
      return <IconMultiAccountManagement fill={fill} />;
    case 'office':
      return <IconOffice fill={fill} />;
    case 'overdraft':
      return <IconOverdraft fill={fill} />;
    case 'pdf-thumbnail':
      return <IconPdfThumbnail fill={fill} />;
    case 'request-money':
      return <IconRequestMoney fill={fill} />;
    case 'request-money/api-offline/cash-in':
      return <IconApiOfflineCashIn fill={fill} />;
    case 'request-money/offline-cash-deposit':
      return <IconCash fill={fill} />;
    case 'cash':
      return <IconCash fill={fill} />;
    case 'star':
      return <IconStar fill={fill} />;
    case 'star-border':
      return <IconStarBorder fill={fill} />;
    case 'star-angled':
      return <IconStarAngled fill={fill} />;
    case 'star-angled-border':
      return <IconStarAngledBorder fill={fill} />;
    case 'time-filled':
      return <IconTimeFilled fill={fill} />;
    case 'time-outline':
      return <IconTimeOutline fill={fill} />;
    case 'request-money/e-wallet':
      return <IconApiEwallet fill={fill} />;
    case 'bank':
      return <IconBank fill={fill} />;
    case 'e-wallet':
      return <IconEwallet fill={fill} />;
    case 'cc':
      return <IconCreditCard fill={fill} />;
    case 'receipt':
      return <IconReceipt fill={fill} />;
    case 'retail':
      return <IconRetail fill={fill} />;
    case 'rupiah-filled':
      return <IconRupiahFilled fill={fill} />;
    case 'rupiah':
      return <IconRupiah fill={fill} />;
    case 'safe-box':
      return <IconSafeBox fill={fill} />;
    case 'credit-debit-card':
      return <IconCreditDebitCard fill={fill} />;
    case 'plan':
      return <IconPlan fill={fill} />;
    case 'pen':
      return <IconPen fill={fill} />;
    case 'promo':
      return <IconPromo fill={fill} />;
    case 'qris':
      return <IconQris fill={fill} />;
    case 'reply':
      return <IconReply fill={fill} />;
    case 'request-money/invoice':
      return <IconInvoice fill={fill} />;
    case 'request-money/client-management':
      return <IconMultiAccountManagement fill={fill} />;
    case 'request-money/payment-checkout':
      return <IconPaymentCheckout fill={fill} />;
    case 'request-money/payment-routing':
      return <IconPaymentRouting fill={fill} />;
    case 'save':
      return <IconSave fill={fill} />;
    case 'search':
      return <IconSearch fill={fill} />;
    case 'security':
      return <IconSecurity fill={fill} />;
    case 'send-money':
      return <IconSendMoney fill={fill} />;
    case 'settings':
      return <IconSettings fill={fill} />;
    case 'share':
      return <IconShare fill={fill} />;
    case 'shield':
      return <IconShield fill={fill} />;
    case 'sort':
      return <IconSort fill={fill} />;
    case 'spending':
      return <IconSpending />;
    case 'spending-transaction':
      return <IconSpendingTransaction />;
    case 'square-checkmark':
      return <IconSquareCheckmark fill={fill} />;
    case 'square-warning':
      return <IconSquareWarning fill={fill} />;
    case 'warning':
      return <IconWarning fill={fill} />;
    case 'transaction-list':
      return <IconTransactionList fill={fill} />;
    case 'transaction-report':
      return <IconTransactionReport fill={fill} />;
    case 'top-up':
      return <IconTopUp fill={fill} />;
    case 'upload':
      return <IconUpload fill={fill} />;
    case 'vendor':
      return <IconVendor fill={fill} />;
    case 'virtual-account':
      return <IconVirtualAccount fill={fill} />;
    case 'vmark':
      return <IconVmark fill={fill} />;
    case 'withdrawal':
      return <IconWithdrawal fill={fill} />;
    case 'phone':
      return <IconPhone fill={fill} />;
    case 'xlsx-thumbnail':
      return <IconXlsxThumbnail fill={fill} />;
    case 'xlsx-thumbnail-text':
      return <IconXlsxThumbnailText fill={fill} />;
    case 'whatsapp':
      return <IconWhatsApp fill={fill} />;
    case 'done':
      return <IconDone fill={fill} />;
    case 'loading':
      return <IconLoading fill={fill} />;
    case 'id':
      return <IconBahasa />;
    case 'en':
      return <IconEnglish />;
    case 'keyboard':
      return <IconKeyboard />;
    case 'upload-file':
      return <IconUploadFile />;
    case 'edit-border':
      return <IconEditBorder fill={fill} />;
    case 'square-uncheck':
      return <IconSquareUncheck />;
    case 'square-check':
      return <IconSquareCheck />;
    case 'past-due-date':
      return <IconPastDueDate fill={fill} />;
    case 'pending-income':
      return <IconPendingIncome fill={fill} />;
    case 'refresh':
      return <IconRefresh fill={fill} />;
    default:
      return <span />;
  }
};

export default RenderIcons;
